import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import airplane_icon_negative from 'components/assets/img/icons/airplane-negative.svg';
import classNames from 'classnames';
import { setChildrenNumber, setAdultsNumber } from 'components/actions/bookingActions';
import withRouter from 'components/components/common/withRouter';
import FlightHelper from 'components/common/helpers/FlightHelper';
import T from 'components/common/translations/Translate';
import TransHelper from 'components/common/translations/TransHelper';

class ReservationSummary extends Component {

  trans = (key, prefix = "content.common") => {
    return TransHelper.translate(this.props.locale, prefix + '.' + key);
  }

  render() {
    const { editMode, reservation, locale } = this.props;
    const classColumnSummary = classNames(
      'grid-layout__item',
      'grid-layout__item--desc',
      'grid-layout__item--content-center',
      'grid-layout__item--transparent',
      { 'grid-layout__item--hidden': editMode }
    );
    var flightHelper = new FlightHelper(
      reservation.flight,
      locale,
      reservation.reservation_direction
    );
    return (
      <div className={classColumnSummary}>
        <div className={classNames(
          'content__desc',
          'dashboard-summary',
          'dashboard-summary--negative'
        )}>
          <ul className="list-summary list-summary--cell">
            <li className="list-summary__item">
              <div className="list-summary__header">
                <div className="text-bold">{flightHelper.getLabel()}</div>
                <div>{flightHelper.getFlightDate()}</div>
              </div>
              <div className="list-summary__address">
                <p style={{textAlign: 'center', marginBottom: '10px'}}>
                  <FontAwesomeIcon
                    icon={['fas', 'map-marker-alt']}
                    color="#ccc"
                  />
                  {reservation.timetable_info}
                </p>
              </div>
              <div className="list-summary__desc">
                <div>{flightHelper.getFrom()}</div>
                <div><img src={airplane_icon_negative} alt="icone airplane" /></div>
                <div>{flightHelper.getTo()}</div>
                <div className="list-flights__time">{flightHelper.getFlighTime()}</div>
              </div>
            </li>
            <li className="list-summary__item list-summary__item--adults">
              <p>
                <FontAwesomeIcon
                  icon={['fas', 'users']}
                  color="#ccc"
                />
                <span className="list-summmary__label">{this.trans('adults')} : </span>
                <span style={{ marginRight: '20px' }}>{reservation.adults}</span>
                <span className="list-summmary__label">{this.trans('kids')} : </span>
                <span>{reservation.children}</span>
              </p>
            </li>
            <li className="list-summary__item list-summary__item--price">
              <FontAwesomeIcon
                icon={['fas', 'credit-card']}
                color="#ccc"
              />
              <span className="list-summmary__label">{this.trans('price')}:</span>
              {' '}
              {parseFloat(reservation.price)}
              {' '}
              <span className="currency">{this.trans('currency')}</span>
              {reservation.payment_to_driver
                ?
                <em>({this.trans('payToDriver', 'content.dashboard')})</em>
                :
                <em>({this.trans('payWithCard', 'content.dashboard')})</em>
              }
            </li>
          </ul>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    reservation: state.service.editedReservation
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    { setChildrenNumber, setAdultsNumber }
  )(ReservationSummary)
);
